<template>
  <div class="safety">
    <div class="safetyTitle">Safety</div>
    <div class="safetyWrapper groupFields_wrap">
      <div>
        <div class="groupFields">
          <field
            :class-error="
              valid.safety_rate_driver && valid.safety_rate_driver.$error
            "
            margin="10px 0 0"
            width="120px"
            type="number"
            label="Rate amount"
            placeholder="0"
            :setInputValue="safety_rate_driver"
            @updateInput="onInput($event, 'safety_rate_driver')"
            is-required
          ></field>
          <field
            margin="10px 0 0 10px"
            width="270px"
            label="Sale manager"
            placeholder="Employee"
            @updateAutocomplete="onManagerAutocomplete"
            :autocompleteValue="creator"
            :items="dispatchersList"
            is-autocomplete
          ></field>
        </div>
        <drivers
          @updateDriversData="onDriversData"
          :drivers="driversList"
          :safety_rate_driver="safety_rate_driver"
          @updateEldPopup="onEldPopup($event, true)"
        ></drivers>
      </div>
	    <div  style="margin: 10px 20px 0;">
		    <field
				    margin="0"
				    min-height="100px"
				    width="100%"
				    label="Safety Service Info"
				    placeholder="Enter information"
				    :setInputValue="information"
				    @updateInput="onInput($event, 'information')"
				    is-auto-grow
				    is-textarea
		    ></field>
		    <small style="margin: 3px 0 0;">
			    Displayed in the table where the CustomerLink component is used
		    </small>
	    </div>

    </div>
    <eld-popup
        v-if="isEldPopup"
        :item="item"
        @updateCloseEldPopup="onEldPopup({}, false)"
        @updateEld="onEld"
    ></eld-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// components
import Drivers from "@/components/Maintenance/Customer/CustomerForm/SecondTab/Safety/Drivers/Drivers.vue";
import EldPopup from "@/components/Maintenance/Customer/CustomerForm/SecondTab/Safety/EldPopup/EldPopup.vue";

export default {
	name: "Safety",
	components: {
		Drivers,
		EldPopup,
	},
	props: {
		dispatchersList: Array,
		driversList: Array,
		serviceList: Object,
		safety_rate_driver: [ Number, String ],
		information: String,
		valid: Object,
	},
	computed: mapGetters([ "customersList" ]),
	data: () => ({
		creator: null,
		drivers: [],
		isEldPopup: false,
		item: null,
		itemIdx: null,
	}),
	methods: {
		onEld(values) {
			this.isEldPopup = false;
			this.item = { ...this.item, ...values };
			this.$emit("updateItemEld", { item: this.item, idx: this.itemIdx });
		},
		onEldPopup({ item, idx }, value) {
			this.isEldPopup = value;
			if (value) {
				this.item = item;
				this.itemIdx = idx;
			}
		},
		getData() {
			this.$emit("updateSafetyData", { ...this.$data });
		},
		onInput({ value }, key) {
			this.$emit("updateSafetyRate", { value, key });
		},
		onDriversData(driversList) {
			this.drivers = driversList;
			this.getData();
		},
		onManagerAutocomplete({ value }) {
			this.creator = value;
			this.getData();
		},
	},
	mounted() {
		this.drivers = this.driversList;
		const { manager, manager_id } = this.serviceList;
		this.creator = { value: manager, id: manager_id };
	},
};
</script>

<style scoped lang="scss">
@import "safety";
</style>
